var map = {
	"./Aircraft/Airliner_Black.png": 60,
	"./Aircraft/Airliner_Blue.png": 1133,
	"./Aircraft/Airliner_Green.png": 1134,
	"./Aircraft/Airliner_Grey.png": 1135,
	"./Aircraft/Airliner_Red.png": 1136,
	"./Aircraft/Airliner_Yellow.png": 1137,
	"./Aircraft/Airplane_Black.png": 1138,
	"./Aircraft/Airplane_Blue.png": 1139,
	"./Aircraft/Airplane_Green.png": 1140,
	"./Aircraft/Airplane_Grey.png": 1141,
	"./Aircraft/Airplane_Red.png": 1142,
	"./Aircraft/Airplane_Yellow.png": 1143,
	"./Aircraft/Helicopter_Black.png": 1144,
	"./Aircraft/Helicopter_Blue.png": 1145,
	"./Aircraft/Helicopter_Green.png": 1146,
	"./Aircraft/Helicopter_Grey.png": 1147,
	"./Aircraft/Helicopter_Red.png": 1148,
	"./Aircraft/Helicopter_Yellow.png": 1149,
	"./Arrows/093-chevron-1.png": 1150,
	"./Arrows/093-chevron-10.png": 1151,
	"./Arrows/093-chevron-11.png": 1152,
	"./Arrows/093-chevron-2.png": 1153,
	"./Arrows/093-chevron-3.png": 1154,
	"./Arrows/093-chevron-4.png": 1155,
	"./Arrows/093-chevron-5.png": 1156,
	"./Arrows/093-chevron-6.png": 1157,
	"./Arrows/093-chevron-7.png": 1158,
	"./Arrows/093-chevron-8.png": 1159,
	"./Arrows/093-chevron-9.png": 1160,
	"./Arrows/093-chevron.png": 1161,
	"./Arrows/093-compress-1.png": 1162,
	"./Arrows/093-compress.png": 1163,
	"./Arrows/093-curved-arrow-1.png": 1164,
	"./Arrows/093-curved-arrow-2.png": 1165,
	"./Arrows/093-curved-arrow-3.png": 1166,
	"./Arrows/093-curved-arrow.png": 1167,
	"./Arrows/093-diagonal-arrow-1.png": 1168,
	"./Arrows/093-diagonal-arrow-10.png": 1169,
	"./Arrows/093-diagonal-arrow-11.png": 1170,
	"./Arrows/093-diagonal-arrow-12.png": 1171,
	"./Arrows/093-diagonal-arrow-13.png": 1172,
	"./Arrows/093-diagonal-arrow-14.png": 1173,
	"./Arrows/093-diagonal-arrow-15.png": 1174,
	"./Arrows/093-diagonal-arrow-2.png": 1175,
	"./Arrows/093-diagonal-arrow-3.png": 1176,
	"./Arrows/093-diagonal-arrow-4.png": 1177,
	"./Arrows/093-diagonal-arrow-5.png": 1178,
	"./Arrows/093-diagonal-arrow-6.png": 1179,
	"./Arrows/093-diagonal-arrow-7.png": 1180,
	"./Arrows/093-diagonal-arrow-8.png": 1181,
	"./Arrows/093-diagonal-arrow-9.png": 1182,
	"./Arrows/093-diagonal-arrow.png": 1183,
	"./Arrows/093-down-arrow-1.png": 1184,
	"./Arrows/093-down-arrow-2.png": 1185,
	"./Arrows/093-down-arrow-3.png": 1186,
	"./Arrows/093-down-arrow-4.png": 1187,
	"./Arrows/093-down-arrow-5.png": 1188,
	"./Arrows/093-down-arrow.png": 1189,
	"./Arrows/093-exchange-1.png": 1190,
	"./Arrows/093-exchange.png": 1191,
	"./Arrows/093-expand-1.png": 1192,
	"./Arrows/093-expand-2.png": 1193,
	"./Arrows/093-expand-3.png": 1194,
	"./Arrows/093-expand.png": 1195,
	"./Arrows/093-left-arrow-1.png": 1196,
	"./Arrows/093-left-arrow-2.png": 1197,
	"./Arrows/093-left-arrow-3.png": 1198,
	"./Arrows/093-left-arrow-4.png": 1199,
	"./Arrows/093-left-arrow-5.png": 1200,
	"./Arrows/093-left-arrow-6.png": 1201,
	"./Arrows/093-left-arrow.png": 1202,
	"./Arrows/093-move-1.png": 1203,
	"./Arrows/093-move.png": 1204,
	"./Arrows/093-redo-1.png": 1205,
	"./Arrows/093-redo.png": 1206,
	"./Arrows/093-resize-1.png": 1207,
	"./Arrows/093-resize-2.png": 1208,
	"./Arrows/093-resize-3.png": 1209,
	"./Arrows/093-resize.png": 1210,
	"./Arrows/093-right-arrow-1.png": 1211,
	"./Arrows/093-right-arrow-2.png": 1212,
	"./Arrows/093-right-arrow-3.png": 1213,
	"./Arrows/093-right-arrow-4.png": 1214,
	"./Arrows/093-right-arrow-5.png": 1215,
	"./Arrows/093-right-arrow-6.png": 1216,
	"./Arrows/093-right-arrow-7.png": 1217,
	"./Arrows/093-right-arrow.png": 1218,
	"./Arrows/093-scroll-1.png": 1219,
	"./Arrows/093-scroll.png": 1220,
	"./Arrows/093-sort-1.png": 1221,
	"./Arrows/093-sort-2.png": 1222,
	"./Arrows/093-sort-3.png": 1223,
	"./Arrows/093-sort.png": 1224,
	"./Arrows/093-turn-left-1.png": 1225,
	"./Arrows/093-turn-left-2.png": 1226,
	"./Arrows/093-turn-left-3.png": 1227,
	"./Arrows/093-turn-left.png": 1228,
	"./Arrows/093-turn-right-1.png": 1229,
	"./Arrows/093-turn-right-2.png": 1230,
	"./Arrows/093-turn-right-3.png": 1231,
	"./Arrows/093-turn-right.png": 1232,
	"./Arrows/093-undo-1.png": 1233,
	"./Arrows/093-undo.png": 1234,
	"./Arrows/093-up-arrow-1.png": 1235,
	"./Arrows/093-up-arrow-2.png": 1236,
	"./Arrows/093-up-arrow-3.png": 1237,
	"./Arrows/093-up-arrow-4.png": 1238,
	"./Arrows/093-up-arrow-5.png": 1239,
	"./Arrows/093-up-arrow-6.png": 1240,
	"./Arrows/093-up-arrow.png": 1241,
	"./Assets/151-actions.png": 1242,
	"./Assets/151-advert.png": 1243,
	"./Assets/151-antennas.png": 1244,
	"./Assets/151-archives.png": 1245,
	"./Assets/151-attached.png": 1246,
	"./Assets/151-banker.png": 1247,
	"./Assets/151-barrow.png": 1248,
	"./Assets/151-bed-side.png": 1249,
	"./Assets/151-beds.png": 1250,
	"./Assets/151-blackboard.png": 1251,
	"./Assets/151-blocked.png": 1252,
	"./Assets/151-book-bag-1.png": 1253,
	"./Assets/151-book-bag.png": 1254,
	"./Assets/151-bridges.png": 1255,
	"./Assets/151-calculations.png": 1256,
	"./Assets/151-carrier.png": 1257,
	"./Assets/151-ceremonial.png": 1258,
	"./Assets/151-chairs.png": 1259,
	"./Assets/151-cleaned.png": 1260,
	"./Assets/151-closing.png": 1261,
	"./Assets/151-cooling.png": 1262,
	"./Assets/151-demostration.png": 1263,
	"./Assets/151-deposit.png": 1264,
	"./Assets/151-dialogue.png": 1265,
	"./Assets/151-disturbance.png": 1266,
	"./Assets/151-domestic-phone.png": 1267,
	"./Assets/151-door-key.png": 1268,
	"./Assets/151-door.png": 1269,
	"./Assets/151-doorway.png": 1270,
	"./Assets/151-draws.png": 1271,
	"./Assets/151-driller.png": 1272,
	"./Assets/151-electric-1.png": 1273,
	"./Assets/151-electric-2.png": 1274,
	"./Assets/151-electric.png": 1275,
	"./Assets/151-entrance.png": 1276,
	"./Assets/151-facade-1.png": 1277,
	"./Assets/151-facade.png": 1278,
	"./Assets/151-fader.png": 1279,
	"./Assets/151-file-storage.png": 1280,
	"./Assets/151-fireplace-1.png": 1281,
	"./Assets/151-fireplace.png": 1282,
	"./Assets/151-flats-1.png": 1283,
	"./Assets/151-flats.png": 1284,
	"./Assets/151-frame.png": 1285,
	"./Assets/151-garden-work.png": 1286,
	"./Assets/151-gardener.png": 1287,
	"./Assets/151-gardening.png": 1288,
	"./Assets/151-glamour.png": 1289,
	"./Assets/151-graphic-design.png": 1290,
	"./Assets/151-graphs.png": 1291,
	"./Assets/151-hacksaw.png": 1292,
	"./Assets/151-hand-gesture.png": 1293,
	"./Assets/151-hand-phones.png": 1294,
	"./Assets/151-headphones.png": 1295,
	"./Assets/151-health-care.png": 1296,
	"./Assets/151-hearth.png": 1297,
	"./Assets/151-house-things-1.png": 1298,
	"./Assets/151-house-things-2.png": 1299,
	"./Assets/151-house-things.png": 1300,
	"./Assets/151-house.png": 1301,
	"./Assets/151-houses.png": 1302,
	"./Assets/151-indoor.png": 1303,
	"./Assets/151-industrial-park.png": 1304,
	"./Assets/151-industrial.png": 1305,
	"./Assets/151-interior-design.png": 1306,
	"./Assets/151-invention.png": 1307,
	"./Assets/151-keyword.png": 1308,
	"./Assets/151-kilograms.png": 1309,
	"./Assets/151-ladders.png": 1310,
	"./Assets/151-line-chart.png": 1311,
	"./Assets/151-lover.png": 1312,
	"./Assets/151-mail.png": 1313,
	"./Assets/151-mailed.png": 1314,
	"./Assets/151-mallet.png": 1315,
	"./Assets/151-mansory.png": 1316,
	"./Assets/151-maps-and-flags-1.png": 1317,
	"./Assets/151-maps-and-flags-2.png": 1318,
	"./Assets/151-maps-and-flags-3.png": 1319,
	"./Assets/151-maps-and-flags-4.png": 1320,
	"./Assets/151-maps-and-flags-5.png": 1321,
	"./Assets/151-maps-and-flags-6.png": 1322,
	"./Assets/151-maps-and-flags.png": 1323,
	"./Assets/151-measuring-1.png": 1324,
	"./Assets/151-measuring.png": 1325,
	"./Assets/151-mechanics.png": 1326,
	"./Assets/151-metallic-blind.png": 1327,
	"./Assets/151-money-icons.png": 1328,
	"./Assets/151-monumental.png": 1329,
	"./Assets/151-motorhome.png": 1330,
	"./Assets/151-online-store.png": 1331,
	"./Assets/151-packaging.png": 1332,
	"./Assets/151-paint-roller.png": 1333,
	"./Assets/151-painted.png": 1334,
	"./Assets/151-paper-printer.png": 1335,
	"./Assets/151-paper-work.png": 1336,
	"./Assets/151-picket.png": 1337,
	"./Assets/151-pincers.png": 1338,
	"./Assets/151-plan.png": 1339,
	"./Assets/151-plans.png": 1340,
	"./Assets/151-plumbering-1.png": 1341,
	"./Assets/151-plumbering.png": 1342,
	"./Assets/151-printed.png": 1343,
	"./Assets/151-property.png": 1344,
	"./Assets/151-pruners.png": 1345,
	"./Assets/151-purses.png": 1346,
	"./Assets/151-radiators.png": 1347,
	"./Assets/151-reading-glasses.png": 1348,
	"./Assets/151-real-estate-1.png": 1349,
	"./Assets/151-real-estate-2.png": 1350,
	"./Assets/151-real-estate-3.png": 1351,
	"./Assets/151-real-estate-4.png": 1352,
	"./Assets/151-real-estate-5.png": 1353,
	"./Assets/151-real-estate-6.png": 1354,
	"./Assets/151-real-estate.png": 1355,
	"./Assets/151-relax.png": 1356,
	"./Assets/151-religious.png": 1357,
	"./Assets/151-rent.png": 1358,
	"./Assets/151-reparation.png": 1359,
	"./Assets/151-roof.png": 1360,
	"./Assets/151-sand-clock.png": 1361,
	"./Assets/151-savings.png": 1362,
	"./Assets/151-security-system-1.png": 1363,
	"./Assets/151-security-system.png": 1364,
	"./Assets/151-seventeen.png": 1365,
	"./Assets/151-shower.png": 1366,
	"./Assets/151-single.png": 1367,
	"./Assets/151-sit-down.png": 1368,
	"./Assets/151-skyline.png": 1369,
	"./Assets/151-step-ladder.png": 1370,
	"./Assets/151-storehouse.png": 1371,
	"./Assets/151-studying.png": 1372,
	"./Assets/151-switch-off.png": 1373,
	"./Assets/151-text-file.png": 1374,
	"./Assets/151-title.png": 1375,
	"./Assets/151-tools-and-utensils.png": 1376,
	"./Assets/151-transportation.png": 1377,
	"./Assets/151-trees.png": 1378,
	"./Assets/151-trucks-1.png": 1379,
	"./Assets/151-trucks.png": 1380,
	"./Assets/151-turned-off.png": 1381,
	"./Assets/151-up-1.png": 1382,
	"./Assets/151-up-2.png": 1383,
	"./Assets/151-up.png": 1384,
	"./Assets/151-ventilation.png": 1385,
	"./Assets/151-wc.png": 1386,
	"./Assets/151-wheel-chair.png": 1387,
	"./Assets/151-wheelbarrow.png": 1388,
	"./Assets/151-winch.png": 1389,
	"./Assets/151-work-tools.png": 1390,
	"./Assets/151-worker.png": 1391,
	"./Bikes/Bicycle_Black.png": 1392,
	"./Bikes/Bicycle_Blue.png": 1393,
	"./Bikes/Bicycle_Green.png": 1394,
	"./Bikes/Bicycle_Grey.png": 1395,
	"./Bikes/Bicycle_Red.png": 1396,
	"./Bikes/Bicycle_Yellow.png": 1397,
	"./Bikes/CruiserMotorcycle_Black.png": 1398,
	"./Bikes/CruiserMotorcycle_Blue.png": 1399,
	"./Bikes/CruiserMotorcycle_Green.png": 1400,
	"./Bikes/CruiserMotorcycle_Grey.png": 1401,
	"./Bikes/CruiserMotorcycle_Red.png": 1402,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1403,
	"./Bikes/Motorcycle_Black.png": 1404,
	"./Bikes/Motorcycle_Blue.png": 1405,
	"./Bikes/Motorcycle_Green.png": 1406,
	"./Bikes/Motorcycle_Grey.png": 1407,
	"./Bikes/Motorcycle_Red.png": 1408,
	"./Bikes/Motorcycle_Yellow.png": 1409,
	"./Bikes/QuadBike_Black.png": 1410,
	"./Bikes/QuadBike_Blue.png": 1411,
	"./Bikes/QuadBike_Green.png": 1412,
	"./Bikes/QuadBike_Grey.png": 1413,
	"./Bikes/QuadBike_Red.png": 1414,
	"./Bikes/QuadBike_Yellow.png": 1415,
	"./Bikes/Scooter_Black.png": 1416,
	"./Bikes/Scooter_Blue.png": 1417,
	"./Bikes/Scooter_Green.png": 1418,
	"./Bikes/Scooter_Grey.png": 1419,
	"./Bikes/Scooter_Red.png": 1420,
	"./Bikes/Scooter_Yellow.png": 1421,
	"./Bikes/TouringMotorcycle_Black.png": 1422,
	"./Bikes/TouringMotorcycle_Blue.png": 1423,
	"./Bikes/TouringMotorcycle_Gray.png": 1424,
	"./Bikes/TouringMotorcycle_Green.png": 1425,
	"./Bikes/TouringMotorcycle_Red.png": 1426,
	"./Bikes/TouringMotorcycle_Yellow.png": 1427,
	"./Car/Cabriolet_Black.png": 1428,
	"./Car/Cabriolet_Blue.png": 1429,
	"./Car/Cabriolet_Green.png": 1430,
	"./Car/Cabriolet_Grey.png": 1431,
	"./Car/Cabriolet_Red.png": 1432,
	"./Car/Cabriolet_Yellow.png": 1433,
	"./Car/CamperVan_Black.png": 1434,
	"./Car/CamperVan_Blue.png": 1435,
	"./Car/CamperVan_Green.png": 1436,
	"./Car/CamperVan_Grey.png": 1437,
	"./Car/CamperVan_Red.png": 1438,
	"./Car/CamperVan_Yellow.png": 1439,
	"./Car/Car_Black.png": 1440,
	"./Car/Car_Blue.png": 1441,
	"./Car/Car_Green.png": 1442,
	"./Car/Car_Grey.png": 1443,
	"./Car/Car_Red.png": 1444,
	"./Car/Car_Yellow.png": 1445,
	"./Car/ExecutiveCar_Black.png": 1446,
	"./Car/ExecutiveCar_Blue.png": 1447,
	"./Car/ExecutiveCar_Green.png": 1448,
	"./Car/ExecutiveCar_Grey.png": 1449,
	"./Car/ExecutiveCar_Red.png": 1450,
	"./Car/ExecutiveCar_Yellow.png": 1451,
	"./Car/Hatchback_Black.png": 1452,
	"./Car/Hatchback_Blue.png": 1453,
	"./Car/Hatchback_Green.png": 1454,
	"./Car/Hatchback_Grey.png": 1455,
	"./Car/Hatchback_Red.png": 1456,
	"./Car/Hatchback_Yellow.png": 1457,
	"./Car/HybridCar_Black.png": 1458,
	"./Car/HybridCar_Blue.png": 1459,
	"./Car/HybridCar_Green.png": 1460,
	"./Car/HybridCar_Grey.png": 1461,
	"./Car/HybridCar_Red.png": 1462,
	"./Car/HybridCar_Yellow.png": 1463,
	"./Car/Jeep_Black.png": 1464,
	"./Car/Jeep_Blue.png": 1465,
	"./Car/Jeep_Green.png": 1466,
	"./Car/Jeep_Grey.png": 1467,
	"./Car/Jeep_Red.png": 1468,
	"./Car/Jeep_Yellow.png": 1469,
	"./Car/Limousine_Black.png": 1470,
	"./Car/Limousine_Blue.png": 1471,
	"./Car/Limousine_Green.png": 1472,
	"./Car/Limousine_Grey.png": 1473,
	"./Car/Limousine_Red.png": 1474,
	"./Car/Limousine_Yellow.png": 1475,
	"./Car/LuxuryCar__Black.png": 1476,
	"./Car/LuxuryCar__Blue.png": 1477,
	"./Car/LuxuryCar__Gray.png": 1478,
	"./Car/LuxuryCar__Green.png": 1479,
	"./Car/LuxuryCar__Red.png": 1480,
	"./Car/LuxuryCar__Yellow.png": 1481,
	"./Car/MUV_Black.png": 1482,
	"./Car/MUV_Blue.png": 1483,
	"./Car/MUV_Green.png": 1484,
	"./Car/MUV_Grey.png": 1485,
	"./Car/MUV_Red.png": 1486,
	"./Car/MUV_Yellow.png": 1487,
	"./Car/Minibus_Black.png": 1488,
	"./Car/Minibus_Blue.png": 1489,
	"./Car/Minibus_Green.png": 1490,
	"./Car/Minibus_Grey.png": 1491,
	"./Car/Minibus_Red.png": 1492,
	"./Car/Minibus_Yellow.png": 1493,
	"./Car/MinicarTrailer_Black.png": 1494,
	"./Car/MinicarTrailer_Blue.png": 1495,
	"./Car/MinicarTrailer_Green.png": 1496,
	"./Car/MinicarTrailer_Grey.png": 1497,
	"./Car/MinicarTrailer_Red.png": 1498,
	"./Car/MinicarTrailer_Yellow.png": 1499,
	"./Car/Minicar_Black.png": 1500,
	"./Car/Minicar_Blue.png": 1501,
	"./Car/Minicar_Green.png": 1502,
	"./Car/Minicar_Grey.png": 1503,
	"./Car/Minicar_Red.png": 1504,
	"./Car/Minicar_Yellow.png": 1505,
	"./Car/Minitruck_Black.png": 1506,
	"./Car/Minitruck_Blue.png": 1507,
	"./Car/Minitruck_Green.png": 1508,
	"./Car/Minitruck_Grey.png": 1509,
	"./Car/Minitruck_Red.png": 1510,
	"./Car/Minitruck_Yellow.png": 1511,
	"./Car/PanelVan_Black.png": 1512,
	"./Car/PanelVan_Blue.png": 1513,
	"./Car/PanelVan_Green.png": 1514,
	"./Car/PanelVan_Grey.png": 1515,
	"./Car/PanelVan_Red.png": 1516,
	"./Car/PanelVan_Yellow.png": 1517,
	"./Car/Pickup_Black.png": 1518,
	"./Car/Pickup_Blue.png": 1519,
	"./Car/Pickup_Green.png": 1520,
	"./Car/Pickup_Grey.png": 1521,
	"./Car/Pickup_Red.png": 1522,
	"./Car/Pickup_Yellow.png": 1523,
	"./Car/SUV_Black.png": 1524,
	"./Car/SUV_Blue.png": 1525,
	"./Car/SUV_Green.png": 1526,
	"./Car/SUV_Grey.png": 1527,
	"./Car/SUV_Red.png": 1528,
	"./Car/SUV_Yellow.png": 1529,
	"./Car/ServiceVan_Black.png": 1530,
	"./Car/ServiceVan_Blue.png": 1531,
	"./Car/ServiceVan_Green.png": 1532,
	"./Car/ServiceVan_Grey.png": 1533,
	"./Car/ServiceVan_Red.png": 1534,
	"./Car/ServiceVan_Yellow.png": 1535,
	"./Car/SportsCar_Black.png": 1536,
	"./Car/SportsCar_Blue.png": 1537,
	"./Car/SportsCar_Green.png": 1538,
	"./Car/SportsCar_Grey.png": 1539,
	"./Car/SportsCar_Red.png": 1540,
	"./Car/SportsCar_Yellow.png": 1541,
	"./Car/StationWagon_Black.png": 1542,
	"./Car/StationWagon_Blue.png": 1543,
	"./Car/StationWagon_Green.png": 1544,
	"./Car/StationWagon_Grey.png": 1545,
	"./Car/StationWagon_Red.png": 1546,
	"./Car/StationWagon_Yellow.png": 1547,
	"./Car/Van_Black.png": 1548,
	"./Car/Van_Blue.png": 1549,
	"./Car/Van_Green.png": 1550,
	"./Car/Van_Grey.png": 1551,
	"./Car/Van_Red.png": 1552,
	"./Car/Van_Yellow.png": 1553,
	"./Ecommerce/auction.png": 1554,
	"./Ecommerce/badge-1.png": 1555,
	"./Ecommerce/badge-2.png": 1556,
	"./Ecommerce/badge-3.png": 1557,
	"./Ecommerce/badge-4.png": 1558,
	"./Ecommerce/badge.png": 1559,
	"./Ecommerce/barcode.png": 1560,
	"./Ecommerce/bedside-table.png": 1561,
	"./Ecommerce/billing-machine.png": 1562,
	"./Ecommerce/browser-1.png": 1563,
	"./Ecommerce/browser.png": 1564,
	"./Ecommerce/calculator.png": 1565,
	"./Ecommerce/cash-register.png": 1566,
	"./Ecommerce/click.png": 1567,
	"./Ecommerce/clock.png": 1568,
	"./Ecommerce/closed.png": 1569,
	"./Ecommerce/coin-1.png": 1570,
	"./Ecommerce/coin-stack.png": 1571,
	"./Ecommerce/coin.png": 1572,
	"./Ecommerce/comments.png": 1573,
	"./Ecommerce/compact-disc.png": 1574,
	"./Ecommerce/cosmetics.png": 1575,
	"./Ecommerce/coupon.png": 1576,
	"./Ecommerce/credit-card-1.png": 1577,
	"./Ecommerce/credit-card-2.png": 1578,
	"./Ecommerce/credit-card.png": 1579,
	"./Ecommerce/customer-service.png": 1580,
	"./Ecommerce/delivery-cart.png": 1581,
	"./Ecommerce/delivery-truck-1.png": 1582,
	"./Ecommerce/delivery-truck.png": 1583,
	"./Ecommerce/diamond.png": 1584,
	"./Ecommerce/discount.png": 1585,
	"./Ecommerce/email.png": 1586,
	"./Ecommerce/faq.png": 1587,
	"./Ecommerce/gift-card.png": 1588,
	"./Ecommerce/gift.png": 1589,
	"./Ecommerce/groceries.png": 1590,
	"./Ecommerce/help.png": 1591,
	"./Ecommerce/like.png": 1592,
	"./Ecommerce/money-bag.png": 1593,
	"./Ecommerce/money.png": 1594,
	"./Ecommerce/monitor.png": 1595,
	"./Ecommerce/news.png": 1596,
	"./Ecommerce/notepad.png": 1597,
	"./Ecommerce/online-shop-1.png": 1598,
	"./Ecommerce/online-shop-2.png": 1599,
	"./Ecommerce/online-shop-3.png": 1600,
	"./Ecommerce/online-shop.png": 1601,
	"./Ecommerce/open.png": 1602,
	"./Ecommerce/order.png": 1603,
	"./Ecommerce/package-1.png": 1604,
	"./Ecommerce/package-2.png": 1605,
	"./Ecommerce/package-3.png": 1606,
	"./Ecommerce/package.png": 1607,
	"./Ecommerce/padlock.png": 1608,
	"./Ecommerce/piggy-bank.png": 1609,
	"./Ecommerce/placeholder.png": 1610,
	"./Ecommerce/price-tag.png": 1611,
	"./Ecommerce/promotion.png": 1612,
	"./Ecommerce/purse.png": 1613,
	"./Ecommerce/qr-code.png": 1614,
	"./Ecommerce/receipt.png": 1615,
	"./Ecommerce/refund.png": 1616,
	"./Ecommerce/return.png": 1617,
	"./Ecommerce/review.png": 1618,
	"./Ecommerce/rocket-ship.png": 1619,
	"./Ecommerce/safebox.png": 1620,
	"./Ecommerce/search-1.png": 1621,
	"./Ecommerce/search.png": 1622,
	"./Ecommerce/shield.png": 1623,
	"./Ecommerce/shirt-1.png": 1624,
	"./Ecommerce/shirt.png": 1625,
	"./Ecommerce/shopping-bag-1.png": 1626,
	"./Ecommerce/shopping-bag-2.png": 1627,
	"./Ecommerce/shopping-bag.png": 1628,
	"./Ecommerce/shopping-basket-1.png": 1629,
	"./Ecommerce/shopping-basket-2.png": 1630,
	"./Ecommerce/shopping-basket-3.png": 1631,
	"./Ecommerce/shopping-basket-4.png": 1632,
	"./Ecommerce/shopping-basket.png": 1633,
	"./Ecommerce/shopping-cart-1.png": 1634,
	"./Ecommerce/shopping-cart-2.png": 1635,
	"./Ecommerce/shopping-cart-3.png": 1636,
	"./Ecommerce/shopping-cart-4.png": 1637,
	"./Ecommerce/shopping-cart.png": 1638,
	"./Ecommerce/smartphone-1.png": 1639,
	"./Ecommerce/smartphone.png": 1640,
	"./Ecommerce/star.png": 1641,
	"./Ecommerce/statistics.png": 1642,
	"./Ecommerce/stock-1.png": 1643,
	"./Ecommerce/stock-2.png": 1644,
	"./Ecommerce/stock.png": 1645,
	"./Ecommerce/stopwatch.png": 1646,
	"./Ecommerce/store.png": 1647,
	"./Ecommerce/survey.png": 1648,
	"./Ecommerce/user.png": 1649,
	"./Ecommerce/wallet.png": 1650,
	"./Ecommerce/wishlist-1.png": 1651,
	"./Ecommerce/wishlist.png": 1652,
	"./Ecommerce/worldwide.png": 1653,
	"./Emergencies/001-air-pump.png": 1654,
	"./Emergencies/002-helicopter.png": 1655,
	"./Emergencies/003-defibrillator.png": 1656,
	"./Emergencies/004-toolbox.png": 1657,
	"./Emergencies/005-smartphone.png": 1658,
	"./Emergencies/006-heart.png": 1659,
	"./Emergencies/007-hospital-2.png": 1660,
	"./Emergencies/008-tools.png": 1661,
	"./Emergencies/009-caution.png": 1662,
	"./Emergencies/010-hospital-1.png": 1663,
	"./Emergencies/011-pin.png": 1664,
	"./Emergencies/012-blood-transfusion.png": 1665,
	"./Emergencies/013-firefighter-1.png": 1666,
	"./Emergencies/014-barrier.png": 1667,
	"./Emergencies/015-fire-truck.png": 1668,
	"./Emergencies/016-police-badge.png": 1669,
	"./Emergencies/017-hospital.png": 1670,
	"./Emergencies/018-bucket.png": 1671,
	"./Emergencies/019-smoke-detector.png": 1672,
	"./Emergencies/020-shovel.png": 1673,
	"./Emergencies/021-walkie-talkie.png": 1674,
	"./Emergencies/022-firefighter.png": 1675,
	"./Emergencies/023-stretcher.png": 1676,
	"./Emergencies/024-lifebuoy.png": 1677,
	"./Emergencies/025-fire-extinguisher.png": 1678,
	"./Emergencies/026-warning.png": 1679,
	"./Emergencies/027-hydrant.png": 1680,
	"./Emergencies/028-matches.png": 1681,
	"./Emergencies/029-phone-call.png": 1682,
	"./Emergencies/030-life-jacket.png": 1683,
	"./Emergencies/031-band-aid.png": 1684,
	"./Emergencies/032-lighter.png": 1685,
	"./Emergencies/033-megaphone.png": 1686,
	"./Emergencies/034-sos.png": 1687,
	"./Emergencies/035-whistle.png": 1688,
	"./Emergencies/036-flashlight.png": 1689,
	"./Emergencies/037-sprinkler.png": 1690,
	"./Emergencies/038-fire-alarm-1.png": 1691,
	"./Emergencies/039-gas-mask.png": 1692,
	"./Emergencies/040-ambulance.png": 1693,
	"./Emergencies/041-emergency-call.png": 1694,
	"./Emergencies/042-first-aid-kit.png": 1695,
	"./Emergencies/043-fire.png": 1696,
	"./Emergencies/044-hose.png": 1697,
	"./Emergencies/045-exit.png": 1698,
	"./Emergencies/046-axe.png": 1699,
	"./Emergencies/047-cone.png": 1700,
	"./Emergencies/048-ladder.png": 1701,
	"./Emergencies/049-siren.png": 1702,
	"./Emergencies/050-fire-alarm.png": 1703,
	"./Family/001-couple-3.png": 1704,
	"./Family/002-house.png": 1705,
	"./Family/003-stroller.png": 1706,
	"./Family/004-son.png": 1707,
	"./Family/005-suitcase.png": 1708,
	"./Family/006-family-2.png": 1709,
	"./Family/007-pet-house.png": 1710,
	"./Family/008-cups.png": 1711,
	"./Family/009-photo-album.png": 1712,
	"./Family/010-fireplace.png": 1713,
	"./Family/011-pin.png": 1714,
	"./Family/012-insurance.png": 1715,
	"./Family/013-swing.png": 1716,
	"./Family/014-sofa.png": 1717,
	"./Family/015-couple-2.png": 1718,
	"./Family/016-home-1.png": 1719,
	"./Family/017-daughter.png": 1720,
	"./Family/018-gift-1.png": 1721,
	"./Family/019-shopping-basket.png": 1722,
	"./Family/020-television.png": 1723,
	"./Family/021-divorce.png": 1724,
	"./Family/022-picture-1.png": 1725,
	"./Family/023-briefcase.png": 1726,
	"./Family/024-graduate.png": 1727,
	"./Family/025-pacifier.png": 1728,
	"./Family/026-beach-ball.png": 1729,
	"./Family/027-love.png": 1730,
	"./Family/028-couple-1.png": 1731,
	"./Family/029-couple.png": 1732,
	"./Family/030-scooter.png": 1733,
	"./Family/031-gift.png": 1734,
	"./Family/032-picture.png": 1735,
	"./Family/033-wedding-rings.png": 1736,
	"./Family/034-wedding-cake.png": 1737,
	"./Family/035-newlyweds.png": 1738,
	"./Family/036-grave.png": 1739,
	"./Family/037-crib.png": 1740,
	"./Family/038-cat.png": 1741,
	"./Family/039-father.png": 1742,
	"./Family/040-dog.png": 1743,
	"./Family/041-care.png": 1744,
	"./Family/042-family-1.png": 1745,
	"./Family/043-grandparents.png": 1746,
	"./Family/044-family.png": 1747,
	"./Family/045-home.png": 1748,
	"./Family/046-motherhood.png": 1749,
	"./Family/047-grandfather.png": 1750,
	"./Family/048-grandmother.png": 1751,
	"./Family/049-newborn.png": 1752,
	"./Family/050-mother.png": 1753,
	"./GPS/compass-1.png": 1754,
	"./GPS/compass.png": 1755,
	"./GPS/gps.png": 1756,
	"./GPS/location-1.png": 1757,
	"./GPS/location-2.png": 1758,
	"./GPS/location-3.png": 1759,
	"./GPS/location.png": 151,
	"./GPS/location3.png": 1760,
	"./GPS/location_green.svg": 289,
	"./GPS/locations.png": 1761,
	"./GPS/map-1.png": 1762,
	"./GPS/map-2.png": 1763,
	"./GPS/map-3.png": 1764,
	"./GPS/map.png": 1765,
	"./GPS/navigator.png": 1766,
	"./GPS/panel.png": 1767,
	"./GPS/pin.png": 1768,
	"./GPS/placeholder-1.png": 1769,
	"./GPS/placeholder-2.png": 1770,
	"./GPS/placeholder-3.png": 1771,
	"./GPS/placeholder-4.png": 1772,
	"./GPS/placeholder-5.png": 1773,
	"./GPS/placeholder-6.png": 1774,
	"./GPS/placeholder-7.png": 1775,
	"./GPS/placeholder.png": 129,
	"./GPS/push-pin.png": 1776,
	"./GPS/route-1.png": 1777,
	"./GPS/route.png": 1778,
	"./GPS/satellite.png": 1779,
	"./GPS/selectLocation.svg": 163,
	"./GPS/smartphone-1.png": 1780,
	"./GPS/smartphone.png": 1781,
	"./GPS/target.png": 1782,
	"./Home/alarm-clock.png": 1783,
	"./Home/alcoholic-1.png": 1784,
	"./Home/alcoholic.png": 1785,
	"./Home/bake.png": 1786,
	"./Home/bathing.png": 1787,
	"./Home/bedroom-1.png": 1788,
	"./Home/bedroom-2.png": 1789,
	"./Home/bedroom-3.png": 1790,
	"./Home/bedroom-4.png": 1791,
	"./Home/bedroom-5.png": 1792,
	"./Home/bedroom-6.png": 1793,
	"./Home/bedroom.png": 1794,
	"./Home/bookcase.png": 1795,
	"./Home/carpenter.png": 1796,
	"./Home/carpet.png": 1797,
	"./Home/chairs-1.png": 1798,
	"./Home/chairs-2.png": 1799,
	"./Home/chairs.png": 1800,
	"./Home/chinese-food.png": 1801,
	"./Home/coffee-cup-1.png": 1802,
	"./Home/coffee-cup-2.png": 1803,
	"./Home/coffee-shop.png": 1804,
	"./Home/coffees.png": 1805,
	"./Home/comfortable-1.png": 1806,
	"./Home/comfortable.png": 1807,
	"./Home/coolnes.png": 1808,
	"./Home/couch.png": 1809,
	"./Home/door-key.png": 1810,
	"./Home/drinking.png": 1811,
	"./Home/elegant.png": 1812,
	"./Home/firefighting.png": 1813,
	"./Home/fry.png": 1814,
	"./Home/game-console.png": 1815,
	"./Home/garbage-bin.png": 1816,
	"./Home/gardening.png": 1817,
	"./Home/hair-salon.png": 1818,
	"./Home/hangers.png": 1819,
	"./Home/home-repair.png": 1820,
	"./Home/hot-drink.png": 1821,
	"./Home/hygienic-1.png": 1822,
	"./Home/hygienic.png": 1823,
	"./Home/invention.png": 1824,
	"./Home/japanese-food.png": 1825,
	"./Home/kitchen-pack-1.png": 1826,
	"./Home/kitchen-pack-10.png": 1827,
	"./Home/kitchen-pack-11.png": 1828,
	"./Home/kitchen-pack-12.png": 1829,
	"./Home/kitchen-pack-13.png": 1830,
	"./Home/kitchen-pack-14.png": 1831,
	"./Home/kitchen-pack-15.png": 1832,
	"./Home/kitchen-pack-16.png": 1833,
	"./Home/kitchen-pack-2.png": 1834,
	"./Home/kitchen-pack-3.png": 1835,
	"./Home/kitchen-pack-4.png": 1836,
	"./Home/kitchen-pack-5.png": 1837,
	"./Home/kitchen-pack-6.png": 1838,
	"./Home/kitchen-pack-7.png": 1839,
	"./Home/kitchen-pack-8.png": 1840,
	"./Home/kitchen-pack-9.png": 1841,
	"./Home/kitchen-pack.png": 1842,
	"./Home/kitchen-tools.png": 1843,
	"./Home/laptop-computer.png": 1844,
	"./Home/livingroom-1.png": 1845,
	"./Home/livingroom-2.png": 1846,
	"./Home/livingroom.png": 1847,
	"./Home/passkey.png": 1848,
	"./Home/phone-call.png": 1849,
	"./Home/phone-receiver.png": 1850,
	"./Home/plugging-1.png": 1851,
	"./Home/plugging.png": 1852,
	"./Home/protein.png": 1853,
	"./Home/real-estate-1.png": 1854,
	"./Home/real-estate-2.png": 1855,
	"./Home/real-estate-3.png": 1856,
	"./Home/real-estate.png": 1857,
	"./Home/reflecting.png": 1858,
	"./Home/refreshment.png": 1859,
	"./Home/restauran.png": 1860,
	"./Home/restroom.png": 1861,
	"./Home/seat.png": 1862,
	"./Home/seatting.png": 1863,
	"./Home/showers.png": 1864,
	"./Home/sinks.png": 1865,
	"./Home/sleepy.png": 1866,
	"./Home/studying-1.png": 1867,
	"./Home/studying-2.png": 1868,
	"./Home/studying.png": 1869,
	"./Home/supper.png": 1870,
	"./Home/technological.png": 1871,
	"./Home/televisions-1.png": 1872,
	"./Home/televisions.png": 1873,
	"./Home/ventilator.png": 1874,
	"./Home/wooden-chair.png": 1875,
	"./Home/yard.png": 1876,
	"./Hospital/ambulance.png": 1877,
	"./Hospital/band-aid.png": 1878,
	"./Hospital/bandage.png": 1879,
	"./Hospital/blood-donation.png": 1880,
	"./Hospital/blood-sample.png": 1881,
	"./Hospital/blood-transfusion.png": 1882,
	"./Hospital/broken-bone.png": 1883,
	"./Hospital/cardiogram.png": 1884,
	"./Hospital/clinic-history.png": 1885,
	"./Hospital/coffee-cup.png": 1886,
	"./Hospital/crutches.png": 1887,
	"./Hospital/dna.png": 1888,
	"./Hospital/doctor.png": 1889,
	"./Hospital/dropper.png": 1890,
	"./Hospital/electrocardiogram.png": 1891,
	"./Hospital/eye-drops.png": 1892,
	"./Hospital/eye.png": 1893,
	"./Hospital/first-aid-kit.png": 1894,
	"./Hospital/flask.png": 1895,
	"./Hospital/hospital-1.png": 1896,
	"./Hospital/hospital-2.png": 1897,
	"./Hospital/hospital-bed.png": 1898,
	"./Hospital/hospital.png": 1899,
	"./Hospital/id-card.png": 1900,
	"./Hospital/laptop.png": 1901,
	"./Hospital/mask.png": 1902,
	"./Hospital/medicine-1.png": 1903,
	"./Hospital/medicine-2.png": 1904,
	"./Hospital/medicine-3.png": 1905,
	"./Hospital/medicine-4.png": 1906,
	"./Hospital/medicine.png": 1907,
	"./Hospital/microscope.png": 1908,
	"./Hospital/nurse.png": 1909,
	"./Hospital/optometry.png": 1910,
	"./Hospital/pill.png": 1911,
	"./Hospital/pills-1.png": 1912,
	"./Hospital/pills.png": 1913,
	"./Hospital/placeholder.png": 1914,
	"./Hospital/prescription.png": 1915,
	"./Hospital/serum.png": 1916,
	"./Hospital/shirt.png": 1917,
	"./Hospital/smartphone.png": 1918,
	"./Hospital/stethoscope.png": 1919,
	"./Hospital/tag.png": 1920,
	"./Hospital/test-tube.png": 1921,
	"./Hospital/thermometer.png": 1922,
	"./Hospital/tooth.png": 1923,
	"./Hospital/vaccine.png": 1924,
	"./Hospital/virus.png": 1925,
	"./Hospital/weight.png": 1926,
	"./Lights/amber_light.png": 1927,
	"./Lights/green_light.png": 1928,
	"./Lights/grey_light.png": 1929,
	"./Lights/red_light.png": 1930,
	"./Lights/traffic_light_green.png": 1931,
	"./Lights/traffic_light_none.png": 1932,
	"./Lights/traffic_light_red.png": 1933,
	"./Lights/trafficlight.png": 1934,
	"./Lights/trafficlightcolour.png": 1935,
	"./Logistics/001-distribution-5.png": 1936,
	"./Logistics/002-aerial.png": 1937,
	"./Logistics/003-frontal-view.png": 1938,
	"./Logistics/004-distribution-4.png": 1939,
	"./Logistics/005-clipboards.png": 1940,
	"./Logistics/006-oceanic.png": 1941,
	"./Logistics/007-placeholders-1.png": 1942,
	"./Logistics/008-international.png": 1943,
	"./Logistics/009-packages-2.png": 1944,
	"./Logistics/010-tools-and-utensils-3.png": 1945,
	"./Logistics/011-weekly-calendar.png": 1946,
	"./Logistics/012-placeholders.png": 1947,
	"./Logistics/013-distribution-3.png": 1948,
	"./Logistics/014-shopping-carts-1.png": 1949,
	"./Logistics/015-maps-and-flags-1.png": 1950,
	"./Logistics/016-organizing.png": 1951,
	"./Logistics/017-maps-and-flags.png": 1952,
	"./Logistics/018-tools-and-utensils-2.png": 1953,
	"./Logistics/019-call-center-1.png": 1954,
	"./Logistics/020-protected.png": 1955,
	"./Logistics/021-cubes.png": 1956,
	"./Logistics/022-distribution-2.png": 1957,
	"./Logistics/023-call-center.png": 1958,
	"./Logistics/024-bussiness.png": 1959,
	"./Logistics/025-charter.png": 1960,
	"./Logistics/026-trolley-cart.png": 1961,
	"./Logistics/027-distribution-1.png": 1962,
	"./Logistics/028-tools-and-utensils-1.png": 1963,
	"./Logistics/029-airplanes.png": 1964,
	"./Logistics/030-verified.png": 1965,
	"./Logistics/031-shopping-carts.png": 1966,
	"./Logistics/032-transportation.png": 1967,
	"./Logistics/033-packages-1.png": 1968,
	"./Logistics/034-changing.png": 1969,
	"./Logistics/035-packages.png": 1970,
	"./Logistics/036-symbolic.png": 1971,
	"./Logistics/037-packing.png": 1972,
	"./Logistics/038-trucks.png": 1973,
	"./Logistics/039-tools-and-utensils.png": 1974,
	"./Logistics/040-circular-arrows.png": 1975,
	"./Logistics/041-debit-card.png": 1976,
	"./Logistics/042-24-hours.png": 1977,
	"./Logistics/043-distribution.png": 1978,
	"./Logistics/044-cargo-ship.png": 1979,
	"./Machinery/BackhoeLoader_Black.png": 1980,
	"./Machinery/BackhoeLoader_Blue.png": 1981,
	"./Machinery/BackhoeLoader_Green.png": 1982,
	"./Machinery/BackhoeLoader_Grey.png": 1983,
	"./Machinery/BackhoeLoader_Red.png": 1984,
	"./Machinery/BackhoeLoader_Yellow.png": 1985,
	"./Machinery/Bulldozer_Black.png": 1986,
	"./Machinery/Bulldozer_Blue.png": 1987,
	"./Machinery/Bulldozer_Green.png": 1988,
	"./Machinery/Bulldozer_Grey.png": 1989,
	"./Machinery/Bulldozer_Red.png": 1990,
	"./Machinery/Bulldozer_Yellow.png": 1991,
	"./Machinery/CompactExcavator_Black.png": 1992,
	"./Machinery/CompactExcavator_Blue.png": 1993,
	"./Machinery/CompactExcavator_Green.png": 1994,
	"./Machinery/CompactExcavator_Grey.png": 1995,
	"./Machinery/CompactExcavator_Red.png": 1996,
	"./Machinery/CompactExcavator_Yellow.png": 1997,
	"./Machinery/Excavator_Black.png": 1998,
	"./Machinery/Excavator_Blue.png": 1999,
	"./Machinery/Excavator_Green.png": 2000,
	"./Machinery/Excavator_Grey.png": 2001,
	"./Machinery/Excavator_Red.png": 2002,
	"./Machinery/Excavator_Yellow.png": 2003,
	"./Machinery/FarmTractor_Black.png": 2004,
	"./Machinery/FarmTractor_Blue.png": 2005,
	"./Machinery/FarmTractor_Green.png": 2006,
	"./Machinery/FarmTractor_Grey.png": 2007,
	"./Machinery/FarmTractor_Red.png": 2008,
	"./Machinery/FarmTractor_Yellow.png": 2009,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 2010,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 2011,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 2012,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 2013,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 2014,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 2015,
	"./Machinery/ForkliftTruck__Black.png": 2016,
	"./Machinery/ForkliftTruck__Blue.png": 2017,
	"./Machinery/ForkliftTruck__Green.png": 2018,
	"./Machinery/ForkliftTruck__Grey.png": 2019,
	"./Machinery/ForkliftTruck__Red.png": 2020,
	"./Machinery/ForkliftTruck__Yellow.png": 2021,
	"./Machinery/LandfillCompactor_Black.png": 2022,
	"./Machinery/LandfillCompactor_Blue.png": 2023,
	"./Machinery/LandfillCompactor_Green.png": 2024,
	"./Machinery/LandfillCompactor_Grey.png": 2025,
	"./Machinery/LandfillCompactor_Red.png": 2026,
	"./Machinery/LandfillCompactor_Yellow.png": 2027,
	"./Machinery/Loader_Black.png": 2028,
	"./Machinery/Loader_Blue.png": 2029,
	"./Machinery/Loader_Green.png": 2030,
	"./Machinery/Loader_Grey.png": 2031,
	"./Machinery/Loader_Red.png": 2032,
	"./Machinery/Loader_Yellow.png": 2033,
	"./Machinery/MaterialHandler_Black.png": 2034,
	"./Machinery/MaterialHandler_Blue.png": 2035,
	"./Machinery/MaterialHandler_Green.png": 2036,
	"./Machinery/MaterialHandler_Grey.png": 2037,
	"./Machinery/MaterialHandler_Red.png": 2038,
	"./Machinery/MaterialHandler_Yellow.png": 2039,
	"./Machinery/RoadRoller_Black.png": 2040,
	"./Machinery/RoadRoller_Blue.png": 2041,
	"./Machinery/RoadRoller_Green.png": 2042,
	"./Machinery/RoadRoller_Grey.png": 2043,
	"./Machinery/RoadRoller_Red.png": 2044,
	"./Machinery/RoadRoller_Yellow.png": 2045,
	"./Machinery/RoadSweeper_Black.png": 2046,
	"./Machinery/RoadSweeper_Blue.png": 2047,
	"./Machinery/RoadSweeper_Green.png": 2048,
	"./Machinery/RoadSweeper_Grey.png": 2049,
	"./Machinery/RoadSweeper_Red.png": 2050,
	"./Machinery/RoadSweeper_Yellow.png": 2051,
	"./Machinery/RollerCompactor_Black.png": 2052,
	"./Machinery/RollerCompactor_Blue.png": 2053,
	"./Machinery/RollerCompactor_Green.png": 2054,
	"./Machinery/RollerCompactor_Grey.png": 2055,
	"./Machinery/RollerCompactor_Red.png": 2056,
	"./Machinery/RollerCompactor_Yellow.png": 2057,
	"./Machinery/SkidSteerLoader_Black.png": 2058,
	"./Machinery/SkidSteerLoader_Blue.png": 2059,
	"./Machinery/SkidSteerLoader_Green.png": 2060,
	"./Machinery/SkidSteerLoader_Grey.png": 2061,
	"./Machinery/SkidSteerLoader_Red.png": 2062,
	"./Machinery/SkidSteerLoader_Yellow.png": 2063,
	"./Machinery/SkipLoader_Black.png": 2064,
	"./Machinery/SkipLoader_Blue.png": 2065,
	"./Machinery/SkipLoader_Green.png": 2066,
	"./Machinery/SkipLoader_Grey.png": 2067,
	"./Machinery/SkipLoader_Red.png": 2068,
	"./Machinery/SkipLoader_Yellow.png": 2069,
	"./Machinery/SoilStabilizer_Black.png": 2070,
	"./Machinery/SoilStabilizer_Blue.png": 2071,
	"./Machinery/SoilStabilizer_Green.png": 2072,
	"./Machinery/SoilStabilizer_Grey.png": 2073,
	"./Machinery/SoilStabilizer_Red.png": 2074,
	"./Machinery/SoilStabilizer_Yellow.png": 2075,
	"./Machinery/SteamRoller_Black.png": 2076,
	"./Machinery/SteamRoller_Blue.png": 2077,
	"./Machinery/SteamRoller_Green.png": 2078,
	"./Machinery/SteamRoller_Grey.png": 2079,
	"./Machinery/SteamRoller_Red.png": 2080,
	"./Machinery/SteamRoller_Yellow.png": 2081,
	"./Machinery/StreetSweeper_Black.png": 2082,
	"./Machinery/StreetSweeper_Blue.png": 2083,
	"./Machinery/StreetSweeper_Green.png": 2084,
	"./Machinery/StreetSweeper_Grey.png": 2085,
	"./Machinery/StreetSweeper_Red.png": 2086,
	"./Machinery/StreetSweeper_Yellow.png": 2087,
	"./Machinery/TelescopicHandler_Black.png": 2088,
	"./Machinery/TelescopicHandler_Blue.png": 2089,
	"./Machinery/TelescopicHandler_Green.png": 2090,
	"./Machinery/TelescopicHandler_Grey.png": 2091,
	"./Machinery/TelescopicHandler_Red.png": 2092,
	"./Machinery/TelescopicHandler_Yellow.png": 2093,
	"./Machinery/TruckMountedCrane_Working_Black.png": 2094,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 2095,
	"./Machinery/TruckMountedCrane_Working_Green.png": 2096,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 2097,
	"./Machinery/TruckMountedCrane_Working_Red.png": 2098,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 2099,
	"./Machinery/TruckMountedCrane__Black.png": 2100,
	"./Machinery/TruckMountedCrane__Blue.png": 2101,
	"./Machinery/TruckMountedCrane__Green.png": 2102,
	"./Machinery/TruckMountedCrane__Grey.png": 2103,
	"./Machinery/TruckMountedCrane__Red.png": 2104,
	"./Machinery/TruckMountedCrane__Yellow.png": 2105,
	"./Machinery/WheeledExcavator_Black.png": 2106,
	"./Machinery/WheeledExcavator_Blue.png": 2107,
	"./Machinery/WheeledExcavator_Green.png": 2108,
	"./Machinery/WheeledExcavator_Grey.png": 2109,
	"./Machinery/WheeledExcavator_Red.png": 2110,
	"./Machinery/WheeledExcavator_Yellow.png": 2111,
	"./Machinery/WreckingBall_Black.png": 2112,
	"./Machinery/WreckingBall_Blue.png": 2113,
	"./Machinery/WreckingBall_Green.png": 2114,
	"./Machinery/WreckingBall_Grey.png": 2115,
	"./Machinery/WreckingBall_Red.png": 2116,
	"./Machinery/WreckingBall_Yellow.png": 2117,
	"./Marine/001-pirate-3.png": 2118,
	"./Marine/001-whale.png": 2119,
	"./Marine/002-hook.png": 2120,
	"./Marine/002-lifesaver.png": 2121,
	"./Marine/003-round-shot.png": 2122,
	"./Marine/003-sailor-cap-2.png": 2123,
	"./Marine/004-anchor-2.png": 2124,
	"./Marine/004-starfish.png": 2125,
	"./Marine/005-anchor-1.png": 2126,
	"./Marine/005-cannon.png": 2127,
	"./Marine/006-dolphin.png": 2128,
	"./Marine/006-parrot.png": 2129,
	"./Marine/007-island.png": 2130,
	"./Marine/007-knot-1.png": 2131,
	"./Marine/008-pirate-2.png": 2132,
	"./Marine/008-sailor-cap-1.png": 2133,
	"./Marine/009-flag.png": 2134,
	"./Marine/009-key.png": 2135,
	"./Marine/010-barrel.png": 2136,
	"./Marine/010-seagull-1.png": 2137,
	"./Marine/011-boat.png": 2138,
	"./Marine/011-paddle.png": 2139,
	"./Marine/012-pirate-ship.png": 2140,
	"./Marine/012-porthole.png": 2141,
	"./Marine/013-bollard.png": 2142,
	"./Marine/013-gold-ingots.png": 2143,
	"./Marine/014-lighthouse-1.png": 2144,
	"./Marine/014-placeholder.png": 2145,
	"./Marine/015-buoys.png": 2146,
	"./Marine/015-skull-and-bones.png": 2147,
	"./Marine/016-flippers.png": 2148,
	"./Marine/016-sword.png": 2149,
	"./Marine/017-pirate-1.png": 2150,
	"./Marine/017-shirt.png": 2151,
	"./Marine/018-chains.png": 2152,
	"./Marine/018-pipe.png": 2153,
	"./Marine/019-eyepatch.png": 2154,
	"./Marine/019-pipe-1.png": 2155,
	"./Marine/020-compass-2.png": 2156,
	"./Marine/020-gallows.png": 2157,
	"./Marine/021-coin.png": 2158,
	"./Marine/021-radar-1.png": 2159,
	"./Marine/022-compass-1.png": 2160,
	"./Marine/022-rum.png": 2161,
	"./Marine/023-money-bag.png": 2162,
	"./Marine/023-radar.png": 2163,
	"./Marine/024-diving-helmet.png": 2164,
	"./Marine/024-pirate.png": 2165,
	"./Marine/025-bottle.png": 2166,
	"./Marine/025-treasure-map.png": 2167,
	"./Marine/026-captain.png": 2168,
	"./Marine/026-wooden-leg.png": 2169,
	"./Marine/027-helm.png": 2170,
	"./Marine/027-yatch.png": 2171,
	"./Marine/028-message-in-a-bottle.png": 2172,
	"./Marine/028-oars.png": 2173,
	"./Marine/029-lighthouse.png": 2174,
	"./Marine/029-ship.png": 2175,
	"./Marine/030-binoculars.png": 2176,
	"./Marine/030-torch.png": 2177,
	"./Marine/031-jolly-roger.png": 2178,
	"./Marine/031-propeller.png": 2179,
	"./Marine/032-bell.png": 2180,
	"./Marine/032-hook.png": 2181,
	"./Marine/033-dice.png": 2182,
	"./Marine/033-map.png": 2183,
	"./Marine/034-sailor-cap.png": 2184,
	"./Marine/034-telescope.png": 2185,
	"./Marine/035-knot.png": 2186,
	"./Marine/035-tortoise.png": 2187,
	"./Marine/036-letter.png": 2188,
	"./Marine/036-waves.png": 2189,
	"./Marine/037-anchor.png": 2190,
	"./Marine/037-pipe.png": 2191,
	"./Marine/038-compass.png": 2192,
	"./Marine/038-lifebuoy.png": 2193,
	"./Marine/039-bomb.png": 2194,
	"./Marine/039-rudder-1.png": 2195,
	"./Marine/040-sailboat.png": 2196,
	"./Marine/040-treasure.png": 2197,
	"./Marine/041-starfish.png": 2198,
	"./Marine/042-lighthouse.png": 2199,
	"./Marine/043-spyglass.png": 2200,
	"./Marine/044-fish.png": 2201,
	"./Marine/045-compass.png": 2202,
	"./Marine/046-anchor.png": 2203,
	"./Marine/047-seagull.png": 2204,
	"./Marine/048-rudder.png": 2205,
	"./Marine/049-snorkel.png": 2206,
	"./Marine/050-life-jacket.png": 2207,
	"./Military/001-knife.png": 2208,
	"./Military/002-bomb-1.png": 2209,
	"./Military/003-radar.png": 2210,
	"./Military/004-medal-1.png": 2211,
	"./Military/005-launcher-1.png": 2212,
	"./Military/006-helmet.png": 2213,
	"./Military/007-chamber.png": 2214,
	"./Military/008-helicopter.png": 2215,
	"./Military/009-soldier.png": 2216,
	"./Military/010-lieutenant.png": 2217,
	"./Military/011-shotgun.png": 2218,
	"./Military/012-backpack.png": 2219,
	"./Military/013-bomb-detonation-1.png": 2220,
	"./Military/014-bomb-detonation.png": 2221,
	"./Military/015-fighter-plane.png": 2222,
	"./Military/016-dynamite.png": 2223,
	"./Military/017-first-aid-kit-1.png": 2224,
	"./Military/018-boat.png": 2225,
	"./Military/019-submarine.png": 2226,
	"./Military/020-compass.png": 2227,
	"./Military/021-insignia.png": 2228,
	"./Military/022-first-aid-kit.png": 2229,
	"./Military/023-placeholder.png": 2230,
	"./Military/024-jet.png": 2231,
	"./Military/025-flag.png": 2232,
	"./Military/026-boots.png": 2233,
	"./Military/027-gas-mask.png": 2234,
	"./Military/028-bullet-1.png": 2235,
	"./Military/029-launcher.png": 2236,
	"./Military/030-satellite-dish.png": 2237,
	"./Military/031-parachute.png": 2238,
	"./Military/032-gun.png": 2239,
	"./Military/033-bulletproof.png": 2240,
	"./Military/034-swiss-army-knife.png": 2241,
	"./Military/035-bullet.png": 2242,
	"./Military/036-binoculars.png": 2243,
	"./Military/037-target.png": 2244,
	"./Military/038-walkie-talkie.png": 2245,
	"./Military/039-rank.png": 2246,
	"./Military/040-barbed.png": 2247,
	"./Military/041-bomb.png": 2248,
	"./Military/042-radiation.png": 2249,
	"./Military/043-chevron.png": 2250,
	"./Military/044-map.png": 2251,
	"./Military/045-medal.png": 2252,
	"./Military/046-tank.png": 2253,
	"./Military/047-tent.png": 2254,
	"./Military/048-dog-tags-military.png": 2255,
	"./Military/049-grenade.png": 2256,
	"./Military/050-badge.png": 2257,
	"./Multimedia/3d-glasses.png": 2258,
	"./Multimedia/antenna.png": 2259,
	"./Multimedia/camera-1.png": 2260,
	"./Multimedia/camera-2.png": 2261,
	"./Multimedia/camera-3.png": 2262,
	"./Multimedia/camera.png": 2263,
	"./Multimedia/cd.png": 2264,
	"./Multimedia/chat.png": 2265,
	"./Multimedia/clapperboard.png": 2266,
	"./Multimedia/cloud.png": 2267,
	"./Multimedia/compact-disc.png": 2268,
	"./Multimedia/dvd.png": 2269,
	"./Multimedia/equalizer.png": 2270,
	"./Multimedia/film.png": 2271,
	"./Multimedia/floppy-disk.png": 2272,
	"./Multimedia/game.png": 2273,
	"./Multimedia/ipod-shuffle.png": 2274,
	"./Multimedia/ipod.png": 2275,
	"./Multimedia/keyboard.png": 2276,
	"./Multimedia/loudspeaker-1.png": 2277,
	"./Multimedia/loudspeaker.png": 2278,
	"./Multimedia/memory-card.png": 2279,
	"./Multimedia/microphone-1.png": 2280,
	"./Multimedia/microphone.png": 2281,
	"./Multimedia/mobile-phone.png": 2282,
	"./Multimedia/modem.png": 2283,
	"./Multimedia/negative-film.png": 2284,
	"./Multimedia/negative.png": 2285,
	"./Multimedia/next-track.png": 2286,
	"./Multimedia/pause.png": 2287,
	"./Multimedia/photos.png": 2288,
	"./Multimedia/play.png": 2289,
	"./Multimedia/previous-track.png": 2290,
	"./Multimedia/radio.png": 2291,
	"./Multimedia/rec.png": 2292,
	"./Multimedia/speaker.png": 2293,
	"./Multimedia/stop.png": 2294,
	"./Multimedia/tablet.png": 2295,
	"./Multimedia/tv-1.png": 2296,
	"./Multimedia/tv.png": 2297,
	"./Multimedia/web-cam.png": 2298,
	"./Office/adhesive-tape.png": 2299,
	"./Office/bookshelf.png": 2300,
	"./Office/box.png": 2301,
	"./Office/briefcase.png": 2302,
	"./Office/business-card.png": 2303,
	"./Office/cabinet.png": 2304,
	"./Office/calculator.png": 2305,
	"./Office/calendar.png": 2306,
	"./Office/clipboard.png": 2307,
	"./Office/clock.png": 2308,
	"./Office/coffee-cup.png": 2309,
	"./Office/computer.png": 2310,
	"./Office/copy-machine.png": 2311,
	"./Office/documents.png": 2312,
	"./Office/fax.png": 2313,
	"./Office/folder-1.png": 2314,
	"./Office/folder-2.png": 2315,
	"./Office/folder.png": 2316,
	"./Office/garbage.png": 2317,
	"./Office/headphones.png": 2318,
	"./Office/highlighter.png": 2319,
	"./Office/hole-puncher.png": 2320,
	"./Office/id-card.png": 2321,
	"./Office/lamp.png": 2322,
	"./Office/laptop.png": 2323,
	"./Office/letters.png": 2324,
	"./Office/mail.png": 2325,
	"./Office/mouse.png": 2326,
	"./Office/mug.png": 2327,
	"./Office/note.png": 2328,
	"./Office/notebook-1.png": 2329,
	"./Office/notebook.png": 2330,
	"./Office/office-chair.png": 2331,
	"./Office/paper-shredder.png": 2332,
	"./Office/pen.png": 2333,
	"./Office/pencil-case.png": 2334,
	"./Office/pendrive.png": 2335,
	"./Office/plant.png": 2336,
	"./Office/presentation.png": 2337,
	"./Office/printer.png": 2338,
	"./Office/projector.png": 2339,
	"./Office/push-pin.png": 2340,
	"./Office/router.png": 2341,
	"./Office/rubber-stamp.png": 2342,
	"./Office/safebox.png": 2343,
	"./Office/stapler.png": 2344,
	"./Office/table.png": 2345,
	"./Office/telephone.png": 2346,
	"./Office/uniform.png": 2347,
	"./Office/webcam.png": 2348,
	"./Professions/astronaut.png": 2349,
	"./Professions/athlete.png": 2350,
	"./Professions/builder.png": 2351,
	"./Professions/carpenter.png": 2352,
	"./Professions/cashier.png": 2353,
	"./Professions/chef.png": 2354,
	"./Professions/chemist.png": 2355,
	"./Professions/clown.png": 2356,
	"./Professions/concierge.png": 2357,
	"./Professions/courier.png": 2358,
	"./Professions/detective.png": 2359,
	"./Professions/diver.png": 2360,
	"./Professions/dj.png": 2361,
	"./Professions/doctor.png": 2362,
	"./Professions/dyer.png": 2363,
	"./Professions/electrician.png": 2364,
	"./Professions/farmer.png": 2365,
	"./Professions/firefighter.png": 2366,
	"./Professions/fisherman.png": 2367,
	"./Professions/gardener.png": 2368,
	"./Professions/hairdresser.png": 2369,
	"./Professions/lumberjack.png": 2370,
	"./Professions/magician.png": 2371,
	"./Professions/maid.png": 2372,
	"./Professions/manager.png": 2373,
	"./Professions/mechanic.png": 2374,
	"./Professions/miner.png": 2375,
	"./Professions/nurse.png": 2376,
	"./Professions/painter.png": 2377,
	"./Professions/pensioner.png": 2378,
	"./Professions/personplaceholder.png": 377,
	"./Professions/photographer.png": 2379,
	"./Professions/pilot.png": 2380,
	"./Professions/plumber.png": 2381,
	"./Professions/policeman.png": 2382,
	"./Professions/politician.png": 2383,
	"./Professions/postman.png": 2384,
	"./Professions/priest.png": 2385,
	"./Professions/professor.png": 2386,
	"./Professions/programmer.png": 2387,
	"./Professions/sailor.png": 2388,
	"./Professions/secretary.png": 2389,
	"./Professions/showman.png": 2390,
	"./Professions/singer.png": 2391,
	"./Professions/soldier.png": 2392,
	"./Professions/stewardess.png": 2393,
	"./Professions/support.png": 2394,
	"./Professions/taxi-driver.png": 2395,
	"./Professions/teacher.png": 2396,
	"./Professions/waiter.png": 2397,
	"./Professions/writer.png": 2398,
	"./PublicTransport/Coach_Black.png": 2399,
	"./PublicTransport/Coach_Blue.png": 2400,
	"./PublicTransport/Coach_Green.png": 2401,
	"./PublicTransport/Coach_Grey.png": 2402,
	"./PublicTransport/Coach_Red.png": 2403,
	"./PublicTransport/Coach_Yellow.png": 2404,
	"./PublicTransport/CommuterBus_Black.png": 2405,
	"./PublicTransport/CommuterBus_Blue.png": 2406,
	"./PublicTransport/CommuterBus_Green.png": 2407,
	"./PublicTransport/CommuterBus_Grey.png": 2408,
	"./PublicTransport/CommuterBus_Red.png": 2409,
	"./PublicTransport/CommuterBus_Yellow.png": 2410,
	"./PublicTransport/Taxi_Black.png": 2411,
	"./PublicTransport/Taxi_Blue.png": 2412,
	"./PublicTransport/Taxi_Green.png": 2413,
	"./PublicTransport/Taxi_Grey.png": 2414,
	"./PublicTransport/Taxi_Red.png": 2415,
	"./PublicTransport/Taxi_Yellow.png": 2416,
	"./PublicTransport/TransitBus_Black.png": 2417,
	"./PublicTransport/TransitBus_Blue.png": 2418,
	"./PublicTransport/TransitBus_Green.png": 2419,
	"./PublicTransport/TransitBus_Grey.png": 2420,
	"./PublicTransport/TransitBus_Red.png": 2421,
	"./PublicTransport/TransitBus_Yellow.png": 2422,
	"./Safety/001-fire.png": 2423,
	"./Safety/002-umbrella.png": 2424,
	"./Safety/003-shield-1.png": 2425,
	"./Safety/004-lifebuoy.png": 2426,
	"./Safety/005-cone.png": 2427,
	"./Safety/006-eye.png": 2428,
	"./Safety/007-helmet.png": 2429,
	"./Safety/008-safety-belt.png": 2430,
	"./Safety/009-first-aid-kit.png": 2431,
	"./Safety/010-barbed-wire.png": 2432,
	"./Safety/011-shield.png": 2433,
	"./Safety/012-cctv-1.png": 2434,
	"./Safety/013-cctv.png": 2435,
	"./Safety/014-fire-alarm-1.png": 2436,
	"./Safety/015-hose.png": 2437,
	"./Safety/016-hydrant.png": 2438,
	"./Safety/017-flasher.png": 2439,
	"./Safety/018-kitchen-hood.png": 2440,
	"./Safety/019-air-compressor.png": 2441,
	"./Safety/020-gas-mask.png": 2442,
	"./Safety/021-carbon-monoxide.png": 2443,
	"./Safety/022-extinguisher.png": 2444,
	"./Safety/023-sprinkler.png": 2445,
	"./Safety/024-pull.png": 2446,
	"./Safety/025-fire-alarm.png": 2447,
	"./Safety/026-smoke-detector.png": 2448,
	"./Safety/027-safety-code.png": 2449,
	"./Safety/028-signal.png": 2450,
	"./Safety/029-strongbox.png": 2451,
	"./Safety/030-password.png": 2452,
	"./Safety/031-key.png": 2453,
	"./Safety/032-keyhole.png": 2454,
	"./Safety/033-exit-1.png": 2455,
	"./Safety/034-door.png": 2456,
	"./Safety/035-padlock-1.png": 2457,
	"./Safety/036-padlock.png": 2458,
	"./Safety/037-house.png": 2459,
	"./Safety/038-exit.png": 2460,
	"./Safety/039-bell.png": 2461,
	"./Safety/040-stop.png": 2462,
	"./Safety/041-radiation.png": 2463,
	"./Safety/042-forbidden.png": 2464,
	"./Safety/043-not-touch.png": 2465,
	"./Safety/044-no-smoking.png": 2466,
	"./Safety/045-no-fire.png": 2467,
	"./Safety/046-high-voltage.png": 2468,
	"./Safety/047-fire-sign.png": 2469,
	"./Safety/048-warning.png": 2470,
	"./Safety/049-bomb.png": 2471,
	"./Safety/050-antenna.png": 2472,
	"./Shipping/aeroplane.png": 2473,
	"./Shipping/barcode.png": 2474,
	"./Shipping/box-1.png": 2475,
	"./Shipping/box.png": 2476,
	"./Shipping/boxes.png": 2477,
	"./Shipping/calendar.png": 2478,
	"./Shipping/clipboard.png": 2479,
	"./Shipping/container.png": 2480,
	"./Shipping/delivery-1.png": 2481,
	"./Shipping/delivery-2.png": 2482,
	"./Shipping/delivery-3.png": 2483,
	"./Shipping/delivery-truck.png": 2484,
	"./Shipping/delivery.png": 2485,
	"./Shipping/envelope.png": 2486,
	"./Shipping/find.png": 2487,
	"./Shipping/fragile.png": 2488,
	"./Shipping/gift.png": 2489,
	"./Shipping/laptop.png": 2490,
	"./Shipping/package-1.png": 2491,
	"./Shipping/package-2.png": 2492,
	"./Shipping/package-3.png": 2493,
	"./Shipping/package-4.png": 2494,
	"./Shipping/package-5.png": 2495,
	"./Shipping/package-6.png": 2496,
	"./Shipping/package-7.png": 2497,
	"./Shipping/package.png": 2498,
	"./Shipping/route.png": 2499,
	"./Shipping/safety.png": 2500,
	"./Shipping/ship.png": 2501,
	"./Shipping/shipping.png": 2502,
	"./Shipping/smartphone.png": 2503,
	"./Shipping/stroller.png": 2504,
	"./Shipping/support.png": 2505,
	"./Shipping/train.png": 2506,
	"./Shipping/up.png": 2507,
	"./Shipping/warehouse-1.png": 2508,
	"./Shipping/warehouse-2.png": 2509,
	"./Shipping/warehouse.png": 2510,
	"./Shipping/weight.png": 2511,
	"./Shipping/worldwide.png": 2512,
	"./Tools/atomic.png": 2513,
	"./Tools/awl.png": 2514,
	"./Tools/axe.png": 2515,
	"./Tools/barrels.png": 2516,
	"./Tools/battery-1.png": 2517,
	"./Tools/battery.png": 2518,
	"./Tools/box.png": 2519,
	"./Tools/charging.png": 2520,
	"./Tools/chisel.png": 2521,
	"./Tools/clamp.png": 2522,
	"./Tools/coal.png": 2523,
	"./Tools/compass.png": 2524,
	"./Tools/cutter.png": 2525,
	"./Tools/driller.png": 2526,
	"./Tools/ecology.png": 2527,
	"./Tools/electric-car.png": 2528,
	"./Tools/electric-tower.png": 2529,
	"./Tools/eolic-energy.png": 2530,
	"./Tools/factory.png": 2531,
	"./Tools/faucet.png": 2532,
	"./Tools/file.png": 2533,
	"./Tools/gas-station.png": 2534,
	"./Tools/gas.png": 2535,
	"./Tools/glue.png": 2536,
	"./Tools/hammer-1.png": 2537,
	"./Tools/hammer-2.png": 2538,
	"./Tools/hammer.png": 2539,
	"./Tools/house.png": 2540,
	"./Tools/hydro-power.png": 2541,
	"./Tools/jigsaw.png": 2542,
	"./Tools/ladder.png": 2543,
	"./Tools/level.png": 2544,
	"./Tools/light-bulb.png": 2545,
	"./Tools/low-battery.png": 2546,
	"./Tools/marker.png": 2547,
	"./Tools/mat.png": 2548,
	"./Tools/measuring-tape.png": 2549,
	"./Tools/nail.png": 2550,
	"./Tools/needle.png": 2551,
	"./Tools/nut.png": 2552,
	"./Tools/oil-platform.png": 2553,
	"./Tools/paint-brush-1.png": 2554,
	"./Tools/paint-brush-2.png": 2555,
	"./Tools/paint-brush.png": 2556,
	"./Tools/paint-bucket.png": 2557,
	"./Tools/paint-palette.png": 2558,
	"./Tools/paint-roller.png": 2559,
	"./Tools/pantone.png": 2560,
	"./Tools/pencil.png": 2561,
	"./Tools/pliers-1.png": 2562,
	"./Tools/pliers-2.png": 2563,
	"./Tools/pliers.png": 2564,
	"./Tools/plug.png": 2565,
	"./Tools/power-button.png": 2566,
	"./Tools/power-plant.png": 2567,
	"./Tools/rain.png": 2568,
	"./Tools/recycle.png": 2569,
	"./Tools/renewable-energy-1.png": 2570,
	"./Tools/renewable-energy.png": 2571,
	"./Tools/ruler-1.png": 2572,
	"./Tools/ruler.png": 2573,
	"./Tools/save-energy.png": 2574,
	"./Tools/saw-1.png": 2575,
	"./Tools/saw.png": 2576,
	"./Tools/scissors.png": 2577,
	"./Tools/screw.png": 2578,
	"./Tools/screwdriver.png": 2579,
	"./Tools/set-square.png": 2580,
	"./Tools/shovel-1.png": 2581,
	"./Tools/shovel.png": 2582,
	"./Tools/socket.png": 2583,
	"./Tools/solar-energy.png": 2584,
	"./Tools/spatula.png": 2585,
	"./Tools/tape.png": 2586,
	"./Tools/toolbox.png": 2587,
	"./Tools/usb-cable.png": 2588,
	"./Tools/workplace.png": 2589,
	"./Tools/wrench-1.png": 2590,
	"./Tools/wrench-2.png": 2591,
	"./Tools/wrench.png": 2592,
	"./Traffic/001-highway-1.png": 2593,
	"./Traffic/002-two-ways.png": 2594,
	"./Traffic/003-road-sign.png": 2595,
	"./Traffic/004-barrier.png": 2596,
	"./Traffic/005-right-arrow.png": 2597,
	"./Traffic/006-roundabout.png": 2598,
	"./Traffic/007-prohibition.png": 2599,
	"./Traffic/008-curves.png": 2600,
	"./Traffic/009-intersection-3.png": 2601,
	"./Traffic/010-caravan-1.png": 2602,
	"./Traffic/011-caravan.png": 2603,
	"./Traffic/012-highway.png": 2604,
	"./Traffic/013-traffic-sign-1.png": 2605,
	"./Traffic/014-traffic-sign.png": 2606,
	"./Traffic/015-warning-2.png": 2607,
	"./Traffic/016-gas-station.png": 2608,
	"./Traffic/017-turn-right-2.png": 2609,
	"./Traffic/018-coffee-shop.png": 2610,
	"./Traffic/019-bicycle-1.png": 2611,
	"./Traffic/020-bicycle.png": 2612,
	"./Traffic/021-bump.png": 2613,
	"./Traffic/022-intersection-2.png": 2614,
	"./Traffic/023-turn-1.png": 2615,
	"./Traffic/024-turn-right-1.png": 2616,
	"./Traffic/025-turn-left-1.png": 2617,
	"./Traffic/026-intersection-1.png": 2618,
	"./Traffic/027-intersection.png": 2619,
	"./Traffic/028-waiting.png": 2620,
	"./Traffic/029-horn.png": 2621,
	"./Traffic/030-narrow-road.png": 2622,
	"./Traffic/031-warning-1.png": 2623,
	"./Traffic/032-hill.png": 2624,
	"./Traffic/033-truck.png": 2625,
	"./Traffic/034-pedestrian-2.png": 2626,
	"./Traffic/035-pedestrian-1.png": 2627,
	"./Traffic/036-traffic-light.png": 2628,
	"./Traffic/037-turn.png": 2629,
	"./Traffic/038-slippery.png": 2630,
	"./Traffic/039-no-entry.png": 2631,
	"./Traffic/040-speed-limit.png": 2632,
	"./Traffic/041-humps.png": 2633,
	"./Traffic/042-falling-rocks.png": 2634,
	"./Traffic/043-pedestrian.png": 2635,
	"./Traffic/044-turn-right.png": 2636,
	"./Traffic/045-turn-left.png": 2637,
	"./Traffic/046-u-turn.png": 2638,
	"./Traffic/047-warning.png": 2639,
	"./Traffic/048-no-parking.png": 2640,
	"./Traffic/049-parking.png": 2641,
	"./Traffic/050-danger.png": 2642,
	"./Trailers/BoxTrailer_Black.png": 2643,
	"./Trailers/BoxTrailer_Blue.png": 2644,
	"./Trailers/BoxTrailer_Green.png": 2645,
	"./Trailers/BoxTrailer_Grey.png": 2646,
	"./Trailers/BoxTrailer_Red.png": 2647,
	"./Trailers/BoxTrailer_Yellow.png": 2648,
	"./Trailers/Caravan_Black.png": 2649,
	"./Trailers/Caravan_Blue.png": 2650,
	"./Trailers/Caravan_Green.png": 2651,
	"./Trailers/Caravan_Grey.png": 2652,
	"./Trailers/Caravan_Red.png": 2653,
	"./Trailers/Caravan_Yellow.png": 2654,
	"./Trailers/FullTrailer_Black.png": 2655,
	"./Trailers/FullTrailer_Blue.png": 2656,
	"./Trailers/FullTrailer_Green.png": 2657,
	"./Trailers/FullTrailer_Grey.png": 2658,
	"./Trailers/FullTrailer_Red.png": 2659,
	"./Trailers/FullTrailer_Yellow.png": 2660,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2661,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2662,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2663,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2664,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2665,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2666,
	"./Trailers/TankerTrailer_Black.png": 2667,
	"./Trailers/TankerTrailer_Blue.png": 2668,
	"./Trailers/TankerTrailer_Green.png": 2669,
	"./Trailers/TankerTrailer_Grey.png": 2670,
	"./Trailers/TankerTrailer_Red.png": 2671,
	"./Trailers/TankerTrailer_Yellow.png": 2672,
	"./Trailers/TravelTrailer_Black.png": 2673,
	"./Trailers/TravelTrailer_Blue.png": 2674,
	"./Trailers/TravelTrailer_Green.png": 2675,
	"./Trailers/TravelTrailer_Grey.png": 2676,
	"./Trailers/TravelTrailer_Red.png": 2677,
	"./Trailers/TravelTrailer_Yellow.png": 2678,
	"./Trailers/WaterBowserTrailer_Black.png": 2679,
	"./Trailers/WaterBowserTrailer_Blue.png": 2680,
	"./Trailers/WaterBowserTrailer_Green.png": 2681,
	"./Trailers/WaterBowserTrailer_Grey.png": 2682,
	"./Trailers/WaterBowserTrailer_Red.png": 2683,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2684,
	"./Transportation/aeroplane.png": 2685,
	"./Transportation/airplane.png": 2686,
	"./Transportation/auto-ricksaw.png": 2687,
	"./Transportation/bike.png": 2688,
	"./Transportation/boat.png": 2689,
	"./Transportation/bus-1.png": 2690,
	"./Transportation/bus.png": 2691,
	"./Transportation/cable-car-cabin.png": 2692,
	"./Transportation/car-1.png": 2693,
	"./Transportation/car-2.png": 2694,
	"./Transportation/car-3.png": 2695,
	"./Transportation/car.png": 2696,
	"./Transportation/catamaran.png": 2697,
	"./Transportation/chairlift.png": 2698,
	"./Transportation/classic-car.png": 2699,
	"./Transportation/helicopter.png": 2700,
	"./Transportation/hot-air-balloon.png": 2701,
	"./Transportation/jeep.png": 2702,
	"./Transportation/locomotive.png": 2703,
	"./Transportation/lorry.png": 2704,
	"./Transportation/minibus.png": 2705,
	"./Transportation/monorail.png": 2706,
	"./Transportation/motorbike.png": 2707,
	"./Transportation/quad.png": 2708,
	"./Transportation/sailboat.png": 2709,
	"./Transportation/sailing-ship.png": 2710,
	"./Transportation/school-bus.png": 2711,
	"./Transportation/ship-1.png": 2712,
	"./Transportation/ship-2.png": 2713,
	"./Transportation/ship-3.png": 2714,
	"./Transportation/ship.png": 2715,
	"./Transportation/sidecar.png": 2716,
	"./Transportation/spaceship.png": 2717,
	"./Transportation/sportive-car.png": 2718,
	"./Transportation/submarine.png": 2719,
	"./Transportation/taxi-1.png": 2720,
	"./Transportation/taxi.png": 2721,
	"./Transportation/tractor.png": 2722,
	"./Transportation/train-1.png": 2723,
	"./Transportation/train-2.png": 2724,
	"./Transportation/train.png": 2725,
	"./Transportation/tram.png": 2726,
	"./Transportation/tricycle.png": 2727,
	"./Transportation/trolleybus.png": 2728,
	"./Transportation/truck.png": 2729,
	"./Transportation/ufo.png": 2730,
	"./Transportation/underground.png": 2731,
	"./Transportation/van-1.png": 2732,
	"./Transportation/van.png": 2733,
	"./Transportation/zeppelin.png": 2734,
	"./Trucks/BinTruck_Black.png": 2735,
	"./Trucks/BinTruck_Blue.png": 2736,
	"./Trucks/BinTruck_Green.png": 2737,
	"./Trucks/BinTruck_Grey.png": 2738,
	"./Trucks/BinTruck_Red.png": 2739,
	"./Trucks/BinTruck_Yellow.png": 2740,
	"./Trucks/FuelTankTruck_Black.png": 2741,
	"./Trucks/FuelTankTruck_Blue.png": 2742,
	"./Trucks/FuelTankTruck_Green.png": 2743,
	"./Trucks/FuelTankTruck_Grey.png": 2744,
	"./Trucks/FuelTankTruck_Red.png": 2745,
	"./Trucks/FuelTankTruck_Yellow.png": 2746,
	"./Trucks/HaulTruck_Black.png": 2747,
	"./Trucks/HaulTruck_Blue.png": 2748,
	"./Trucks/HaulTruck_Green.png": 2749,
	"./Trucks/HaulTruck_Grey.png": 2750,
	"./Trucks/HaulTruck_Red.png": 2751,
	"./Trucks/HaulTruck_Yellow.png": 2752,
	"./Trucks/LorryCab_Black.png": 2753,
	"./Trucks/LorryCab_Blue.png": 2754,
	"./Trucks/LorryCab_Green.png": 2755,
	"./Trucks/LorryCab_Grey.png": 2756,
	"./Trucks/LorryCab_Red.png": 2757,
	"./Trucks/LorryCab_Yellow.png": 2758,
	"./Trucks/LorryTrailer_Black.png": 2759,
	"./Trucks/LorryTrailer_Blue.png": 2760,
	"./Trucks/LorryTrailer_Green.png": 2761,
	"./Trucks/LorryTrailer_Grey.png": 2762,
	"./Trucks/LorryTrailer_Red.png": 2763,
	"./Trucks/LorryTrailer_Yellow.png": 2764,
	"./Trucks/Lorry_Black.png": 2765,
	"./Trucks/Lorry_Blue.png": 2766,
	"./Trucks/Lorry_Green.png": 2767,
	"./Trucks/Lorry_Grey.png": 2768,
	"./Trucks/Lorry_Red.png": 2769,
	"./Trucks/Lorry_Yellow.png": 2770,
	"./Trucks/PetroleumTankTruck_Black.png": 2771,
	"./Trucks/PetroleumTankTruck_Blue.png": 2772,
	"./Trucks/PetroleumTankTruck_Green.png": 2773,
	"./Trucks/PetroleumTankTruck_Grey.png": 2774,
	"./Trucks/PetroleumTankTruck_Red.png": 2775,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2776,
	"./Trucks/SkipTruck_Black.png": 2777,
	"./Trucks/SkipTruck_Blue.png": 2778,
	"./Trucks/SkipTruck_Green.png": 2779,
	"./Trucks/SkipTruck_Grey.png": 2780,
	"./Trucks/SkipTruck_Red.png": 2781,
	"./Trucks/SkipTruck_Yellow.png": 2782,
	"./Trucks/TankerTruck_Black.png": 2783,
	"./Trucks/TankerTruck_Blue.png": 2784,
	"./Trucks/TankerTruck_Green.png": 2785,
	"./Trucks/TankerTruck_Grey.png": 2786,
	"./Trucks/TankerTruck_Red.png": 2787,
	"./Trucks/TankerTruck_Yellow.png": 2788,
	"./Trucks/TractorTrailer2_Black.png": 2789,
	"./Trucks/TractorTrailer2_Blue.png": 2790,
	"./Trucks/TractorTrailer2_Green.png": 2791,
	"./Trucks/TractorTrailer2_Grey.png": 2792,
	"./Trucks/TractorTrailer2_Red.png": 2793,
	"./Trucks/TractorTrailer2_Yellow.png": 2794,
	"./Trucks/TractorTrailer_Black.png": 2795,
	"./Trucks/TractorTrailer_Blue.png": 2796,
	"./Trucks/TractorTrailer_Green.png": 2797,
	"./Trucks/TractorTrailer_Grey.png": 2798,
	"./Trucks/TractorTrailer_Red.png": 2799,
	"./Trucks/TractorTrailer_Yellow.png": 2800,
	"./Trucks/TruckV_Black.png": 2801,
	"./Trucks/TruckV_Blue.png": 2802,
	"./Trucks/TruckV_Green.png": 2803,
	"./Trucks/TruckV_Grey.png": 2804,
	"./Trucks/TruckV_Red.png": 2805,
	"./Trucks/TruckV_Yellow.png": 2806,
	"./Trucks/Truck_Black.png": 2807,
	"./Trucks/Truck_Blue.png": 2808,
	"./Trucks/Truck_Green.png": 2809,
	"./Trucks/Truck_Grey.png": 2810,
	"./Trucks/Truck_Red.png": 2811,
	"./Trucks/Truck_Yellow.png": 2812,
	"./Watercraft/Barge_Black.png": 2813,
	"./Watercraft/Barge_Blue.png": 2814,
	"./Watercraft/Barge_Green.png": 2815,
	"./Watercraft/Barge_Grey.png": 2816,
	"./Watercraft/Barge_Red.png": 2817,
	"./Watercraft/Barge_Yellow.png": 2818,
	"./Watercraft/Boat_Black.png": 2819,
	"./Watercraft/Boat_Blue.png": 2820,
	"./Watercraft/Boat_Gray.png": 2821,
	"./Watercraft/Boat_Green.png": 2822,
	"./Watercraft/Boat_Red.png": 2823,
	"./Watercraft/Boat_Yellow.png": 2824,
	"./Watercraft/BulkCarrier_Black.png": 2825,
	"./Watercraft/BulkCarrier_Blue.png": 2826,
	"./Watercraft/BulkCarrier_Green.png": 2827,
	"./Watercraft/BulkCarrier_Grey.png": 2828,
	"./Watercraft/BulkCarrier_Red.png": 2829,
	"./Watercraft/BulkCarrier_Yellow.png": 2830,
	"./Watercraft/Motorboat_Black.png": 2831,
	"./Watercraft/Motorboat_Blue.png": 2832,
	"./Watercraft/Motorboat_Green.png": 2833,
	"./Watercraft/Motorboat_Grey.png": 2834,
	"./Watercraft/Motorboat_Red.png": 2835,
	"./Watercraft/Motorboat_Yellow.png": 2836,
	"./Watercraft/Sailboat_Black.png": 2837,
	"./Watercraft/Sailboat_Blue.png": 2838,
	"./Watercraft/Sailboat_Green.png": 2839,
	"./Watercraft/Sailboat_Grey.png": 2840,
	"./Watercraft/Sailboat_Red.png": 2841,
	"./Watercraft/Sailboat_Yellow.png": 2842,
	"./Watercraft/Tanker_Black.png": 2843,
	"./Watercraft/Tanker_Blue.png": 2844,
	"./Watercraft/Tanker_Green.png": 2845,
	"./Watercraft/Tanker_Grey.png": 2846,
	"./Watercraft/Tanker_Red.png": 2847,
	"./Watercraft/Tanker_Yellow.png": 2848,
	"./Watercraft/WaterMotorcycle_Black.png": 2849,
	"./Watercraft/WaterMotorcycle_Blue.png": 2850,
	"./Watercraft/WaterMotorcycle_Green.png": 2851,
	"./Watercraft/WaterMotorcycle_Grey.png": 2852,
	"./Watercraft/WaterMotorcycle_Red.png": 2853,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;